import { useState, useEffect } from 'react';
import {
  subscribeToRoom,
  hereNow,
  addEventListener,
  removeEventListenerByScope,
  unsubscribeToRoom,
  getUserMetaData,
} from '../helpers/pubNubFunctions';
import { JUNOCustomUser } from '../../types/global';

// Takes a room and a type and listens for presence changes, returning either
// an array of UUID strings or an array of CustomUsers based on the returnUsers param.
// Only return CustomUsers if you need to display them, we have to hit PubNub
// separately for each user's metadata (name, avatar)

export default function usePubNubVisitors(room: string, returnUsers: boolean) {
  const [visitors, setVisitors] = useState<Array<JUNOCustomUser>>([]);

  useEffect(() => {
    subscribeToRoom(room, true);
    hereNow(room, true, false, (status, response) => {
      response.channels[room].occupants
        .map(occupant => occupant.uuid)
        .map(uuid => {
          getUserMetaData(uuid, (status, result) => {
            // @ts-ignore
            const aUser: JUNOCustomUser = new CustomUser();
            aUser.initialize({
              user_firstname: result.data.custom.firstname,
              user_lastname: result.data.custom.lastname,
              user_avatar: result.data.custom.avatar,
              user_id: result.data.externalId,
              chat_room: result.data.id,
            });
            setVisitors(old => [aUser, ...old]);
          });
        });

      //@ts-ignore
      addEventListener(
        // @ts-ignore
        PubNubCenter.ON_PRESENCE,
        (event, presence) => {
          if (presence?.channel == room) {
            switch (presence.action) {
              //@ts-ignore
              case PubNubCenter.PRESENCE_JOIN:
                if (!visitors.find(visitor => visitor.ChatRoom == presence.uuid)) {
                  getUserMetaData(presence.uuid, (status, result) => {
                    const aUser: JUNOCustomUser =
                      // @ts-ignore
                      new CustomUser();
                    aUser.initialize({
                      user_firstname: result.data.custom.firstname,
                      user_lastname: result.data.custom.lastname,
                      user_avatar: result.data.custom.avatar,
                      user_id: result.data.externalId,
                      chat_room: result.data.id,
                    });
                    setVisitors(old => {
                      // double check they're not already in there, the check up top
                      // isn't fully reliable because of the async update
                      if (!old.find(visitor => visitor.ChatRoom == presence.uuid)) {
                        return [aUser, ...old];
                      }
                      return [...old];
                    });
                  });
                }
                break;

              //@ts-ignore
              case PubNubCenter.PRESENCE_LEAVE:
              //@ts-ignore
              case PubNubCenter.PRESENCE_TIMEOUT:
                setVisitors(old => old.filter(user => user.ChatRoom != presence.uuid));
                break;

              //@ts-ignore
              case PubNubCenter.PRESENCE_INTERVAL:
                if (presence.join) {
                  presence.join.map(uuid => {
                    if (!visitors.find(visitor => visitor.ChatRoom == uuid)) {
                      getUserMetaData(uuid, (status, result) => {
                        const aUser: JUNOCustomUser =
                          // @ts-ignore
                          new CustomUser();
                        aUser.initialize({
                          user_firstname: result.data.custom.firstname,
                          user_lastname: result.data.custom.lastname,
                          user_avatar: result.data.custom.avatar,
                          user_id: result.data.externalId,
                          chat_room: result.data.id,
                        });
                        setVisitors(old => {
                          // double check they're not already in there, the check up top
                          // isn't fully reliable because of the async update
                          if (!old.find(visitor => visitor.ChatRoom == uuid)) {
                            return [aUser, ...old];
                          }
                          return [...old];
                        });
                      });
                    }
                  });
                }
                if (presence.leave) {
                  setVisitors(old => old.filter(uuid => !presence.leave.includes(uuid)));
                }
                if (presence.timeout) {
                  setVisitors(old => old.filter(uuid => !presence.timeout.includes(uuid)));
                }

                break;
            }
          }
        },
        'chat_pane_visitor_awareness',
      );
    });

    return () => {
      removeEventListenerByScope(
        //@ts-ignore
        PubNubCenter.ON_PRESENCE,
        'chat_pane_visitor_awareness',
      );
      unsubscribeToRoom(room);
    };
  }, []);

  return [visitors];
}
